const { Age } = require("../Constants/Constants");
const CardData = require("../dataEntities/CardData");
const { CardTypes } = require("../Constants/Names/CardNames");
const Leaders = require("../Constants/Leaders/Leaders");
const Wonders = require("../Constants/Wonders/Wonders");
// (without a setup: the expansion with every leader and wonder, e.g. for the card gallery)
const { Setups, InSetup, SetupVersion, CardVersion, DeckSets } = require("../Constants/CardVersions");
const DefaultSetup = Setups.Expansion;
const { BaseGame, Expansion } = require("./DeckLists");

// The age's leaders and wonders in a game with this setup (a mix: those picked), each changed one in the setup's version
const LeadersAndWonders = (age, setup) => [
    ...Object.keys(Leaders).filter(name => Leaders[name].age === age && InSetup(setup, name, age))
        .map(name => new CardData(CardTypes.CivilCardTypes.Leader, name, age, null, SetupVersion(setup, Leaders, name))),
    ...Object.keys(Wonders).filter(name => Wonders[name].age === age && InSetup(setup, name, age))
        .map(name => new CardData(CardTypes.CivilCardTypes.Wonder, name, age, null, SetupVersion(setup, Wonders, name))),
];

// The cards of a deck list (DeckLists.js) for this many players: each entry's count of copies, each a changed card
// (technology, territory) in the setup's version
const FromList = (entries, age, playerCount, setup) => (entries ?? []).flatMap(([type, name, count]) => {
    const copies = Array.isArray(count) ? count[Math.min(Math.max(playerCount, 2), 4) - 2] : count;
    const version = CardVersion(setup, { type, name, age });
    return Array.from({ length: copies }, () => new CardData(type, name, age, null, version));
});

// The decks of an age (setup: the decks, leaders and wonders, and versions; see Constants/CardVersions.js): the base
// game's, with the expansion's additions when the setup has them
const Deck = (kind, age, playerCount, setup) => [
    ...FromList(BaseGame[kind][age], age, playerCount, setup),
    ...((setup.deck ?? DeckSets.Expansion) === DeckSets.Expansion ? FromList(Expansion[kind][age], age, playerCount, setup) : []),
];

class DeckDataFactory
{
    // The age's civil deck: its cards, and its leaders and wonders (all of the setup's in every game size)
    static GetCivilDeck(age, playerCount, setup = DefaultSetup){
        return [...Deck('civil', age, playerCount, setup), ...LeadersAndWonders(age, setup)];
    }

    static GetMilitaryDeck(age, playerCount, setup = DefaultSetup){
        return Deck('military', age, playerCount, setup);
    }
}

module.exports = {
    DeckDataFactory
}
